export default V => [
  {
    path: 'commons',
    component: V('users/commons/Base'),
    children: [
      {
        name: 'users.commons.list',
        path: '',
        component: V('users/commons/List'),
        meta: {
          title: 'Usuários',
          breadcrumb: [{ title: 'Usuários' }, { title: 'Comuns' }],
        },
        children: [
          {
            name: 'users.commons.list.filter',
            path: 'filter',
            component: V('users/commons/Filter'),
            meta: {
              title: 'Filtrar usuários',
              breadcrumb: [{ title: 'Usuários' }, { title: 'Comuns' }],
            },
          },
        ],
      },

      {
        name: 'users.commons.create',
        path: 'create',
        component: V('users/commons/Form'),
        meta: {
          title: 'Novo usuário',
          breadcrumb: [
            { title: 'Usuários' },
            { title: 'Comuns', name: 'users.commons.list' },
            { title: 'Novo usuário' },
          ],
        },
      },
      {
        name: 'users.commons.edit',
        path: 'edit/:id',
        component: V('users/commons/Form'),
        meta: {
          title: 'Editar usuário',
          breadcrumb: [
            { title: 'Usuários' },
            { title: 'Comuns', name: 'users.commons.list' },
            { title: 'Editar usuário' },
          ],
        },
      },
    ],
  },
]
